/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Select,
  DatePicker,
  Icon,
  Spin,
  Statistic,
  Drawer,
  Divider,
  Input,
  Form,
  message
} from 'antd';
const { Option } = Select;
const { RangePicker } = DatePicker;

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  Label
} from 'recharts';

import {
  ssrHandler,
  fetchActiveReportsMetaData,
  fetchCP,
  fetchOrderCreationStats,
  resetCPs,
  fetchServiceMetaData,
  orderCreationChartChange,
  generateOrderCreationReport
} from '../actions/sessionActions';
import { generateMonthList } from '../utils/assetUtils';

const antIcon = <Icon type="loading" style={{ fontSize: 80 }} spin />;

const DescriptionItem = ({ title, content }) => (
  <div
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
      color: 'rgba(0,0,0,0.65)'
    }}
  >
    <p
      style={{
        marginRight: 8,
        display: 'inline-block',
        color: 'rgba(0,0,0,0.85)'
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

DescriptionItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <h3 className="datetime">{label}</h3>
        <table>
          <thead>
            <tr>
              <th>Courier Partner</th>
              <th>Success</th>
              <th>Failed</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {payload.map((item, i) => (
              <tr key={i}>
                <td>
                  <span
                    style={{
                      backgroundColor: item.stroke,
                      width: 12,
                      height: 12,
                      display: 'inline-block',
                      marginRight: 5
                    }}
                  />
                  {item.name}
                </td>
                <td>{item.payload.orders[item.name].success}</td>
                <td>{item.payload.orders[item.name].failed}</td>
                <td>{item.payload.orders[item.name].total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  return null;
};

const status = [
  { label: 'All', value: 'total' },
  { label: 'Success', value: 'success' },
  { label: 'Failed', value: 'failed' }
];

export class TrackingDelay extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchCp());
  }
  constructor() {
    super();
    this.state = {
      filter: {
        enterpriseId: null,
        cps: [],
        startDate: moment().format('YYYY-MM-DDT00:00:00'),
        endDate: moment().format('YYYY-MM-DDTHH:mm:00'),
        status: 'total'
      },
      enterpriseId: null,
      months: null,
      serviceType: null,
      defaultMonths: generateMonthList(3).map(month => month.value),
      visibleDrawer: false,
      loading: false,
      report_identifier: '',
      emails: [],
      email_to_list: []
    };
  }

  componentDidMount() {
    const { filter } = this.state;
    this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchServiceMetaData();
    this.props.fetchOrderCreationStats(filter);
  }

  reset = () => {
    let { filter } = this.state;
    filter = {
      enterpriseId: null,
      cps: [],
      startDate: '',
      endDate: '',
      status: 'total'
    };
    this.setState({ filter });
    this.props.resetCPs();
    this.props.fetchOrderCreationStats(filter);
  };

  handleChange = (key, value) => {
    const { filter } = this.state;
    filter[key] = value;
    if (key === 'enterpriseId') {
      filter.cps = [];
      if (value) {
        this.props.fetchCP(value);
      } else {
        this.props.resetCPs();
      }
    } else if (key === 'status') {
      this.props.orderCreationChartChange(value);
    }
    this.setState({ filter });
  };

  handleSearch = () => {
    const { filter } = this.state;
    filter.status = 'total';
    this.setState({ filter });
    this.props.fetchOrderCreationStats(filter);
  };

  onRangeChange = (date, dateString) => {
    const { filter } = this.state;
    filter.startDate = dateString[0];
    filter.endDate = dateString[1];
    this.setState({ filter });
  };

  disabledDate = current => {
    return (
      moment().add(-1, 'days') >= current || moment().add(1, 'month') <= current
    );
  };

  ranged = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  disabledRangeTime = (_, type) => {
    if (type === 'start') {
      return {
        disabledHours: () => this.ranged(0, 60).splice(4, 20),
        disabledMinutes: () => this.ranged(30, 60),
        disabledSeconds: () => [55, 56]
      };
    }
    return {
      disabledHours: () => this.ranged(0, 60).splice(20, 4),
      disabledMinutes: () => this.ranged(0, 31),
      disabledSeconds: () => [55, 56]
    };
  };

  openReportView = () => {
    this.setState({ visibleDrawer: true });
  };

  onClose = () => {
    this.setState({
      visibleDrawer: false,
      loading: false,
      report_identifier: '',
      emails: [],
      email_to_list: []
    });
  };

  inputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleEmailChange = email_to_list => {
    this.setState({ email_to_list });
  };

  handleOk = () => {
    const { filter, email_to_list, report_identifier } = this.state;
    let query = {
      report_identifier: report_identifier,
      email_to_list: email_to_list.join(','),
      report_name: 'FAILED_SHIPMENTS_REPORT',
      report_prequisite: {
        start_date: moment(new Date(filter.startDate))
          .utc()
          .format('YYYY-MM-DDTHH:mm:00'),
        end_date: moment(new Date(filter.endDate))
          .utc()
          .format('YYYY-MM-DDTHH:mm:00'),
        service_id: '1',
        enable_enterprise_check: false
      }
    };
    if (filter.cps.length > 0) {
      query.report_prequisite.courier_partner_id = filter.cps.join(',');
    }
    this.setState({ loading: true });
    this.props.generateOrderCreationReport(query).then(res => {
      if (res.meta.success) {
        this.setState({
          loading: false,
          visibleDrawer: false,
          report_identifier: '',
          emails: [],
          email_to_list: []
        });
        message.success('Your data has been successfully submitted.');
      } else {
        this.setState({ loading: false });
        message.error(res.meta.message);
      }
    });
  };

  render() {
    const {
      filter,
      visibleDrawer,
      emails,
      report_identifier,
      email_to_list,
      loading
    } = this.state;
    const { metadata, orderCreation } = this.props;
    const failedOrders =
      orderCreation.list.length > 0
        ? orderCreation.list.reduce(function(total, item) {
            var subTotal = 0;
            for (var key in item.orders) {
              subTotal += item.orders[key].failed;
            }
            return total + subTotal;
          }, 0)
        : 0;

    const successOrders =
      orderCreation.list.length > 0
        ? orderCreation.list.reduce(function(total, item) {
            var subTotal = 0;
            for (var key in item.orders) {
              subTotal += item.orders[key].success;
            }
            return total + subTotal;
          }, 0)
        : 0;

    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col span={4}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="enterpriseId"
                id="enterpriseId"
                // ref={ref => (this.enterpriseId = ref)}
                showSearch
                style={{ width: '96%' }}
                placeholder="Select Enterprise"
                optionFilterProp="children"
                value={filter.enterpriseId ? filter.enterpriseId : undefined}
                onChange={value => this.handleChange('enterpriseId', value)}
                allowClear={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.enterprise.list.map((enterprise, i) => (
                  <Option key={i} value={enterprise.id}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={8}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                placeholder="Please select courier partner"
                value={filter.cps.length > 0 ? filter.cps : undefined}
                mode="multiple"
                style={{ width: '96%' }}
                onChange={value => this.handleChange('cps', value)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.cp.list.map((cp, i) => (
                  <Option key={i} value={cp.id}>
                    {cp.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={8}>
            <div className="global-search-wrapper" style={{ width: '96%' }}>
              <RangePicker
                defaultValue={[
                  moment(filter.startDate),
                  moment(filter.endDate)
                ]}
                onChange={this.onRangeChange}
                showTime={{
                  hideDisabledOptions: true,
                  format: 'YYYY-MM-DDTHH:mm:00'
                }}
                format="YYYY-MM-DDTHH:mm:00"
              />
            </div>
          </Col>
          <Col span={4} className="text-center">
            <Button
              type="primary"
              className="pull-left"
              onClick={this.handleSearch}
            >
              Submit
            </Button>
            <Button type="primary" onClick={this.reset} className="pull-right">
              Reset
            </Button>
          </Col>
        </Row>
        {orderCreation.list.length > 0 ? (
          <Row className="margin-top-20">
            <Col span={1}>
              <h3 style={{ marginTop: '5px' }}>Filter: </h3>
            </Col>
            <Col span={3}>
              <div className="global-search-wrapper" style={{ width: '100%' }}>
                <Select
                  name="status"
                  id="status"
                  showSearch
                  style={{ width: '96%' }}
                  placeholder="Select Status"
                  optionFilterProp="children"
                  value={filter.status ? filter.status : undefined}
                  onChange={value => this.handleChange('status', value)}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {status.map((item, i) => (
                    <Option key={i} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </Col>
            <Col span={3} offset={1}>
              <Statistic
                title="Success Orders"
                value={successOrders}
                valueStyle={{ fontSize: '16px' }}
                className="custom-statistics"
              />
            </Col>
            <Col span={3}>
              <Statistic
                title="Failed Orders"
                value={failedOrders}
                valueStyle={{ fontSize: '16px' }}
                className="custom-statistics"
                suffix={
                  <Icon type="cloud-download" onClick={this.openReportView} />
                }
              />
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col span={24} className="margin-bottom-10">
            {orderCreation.isFetching ? (
              <div
                className="text-center spinner-container"
                style={{ height: '300px' }}
              >
                <Spin indicator={antIcon} />
              </div>
            ) : orderCreation.list.length > 0 ? (
              <LineChart
                width={1200}
                height={300}
                data={orderCreation.list}
                margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date">
                  <Label
                    value="Order Creation Stats"
                    offset={0}
                    position="insideBottom"
                  />
                </XAxis>
                <YAxis
                  label={{
                    value: 'No of orders',
                    angle: -90,
                    position: 'insideLeft'
                  }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend verticalAlign="top" height={36} />
                {orderCreation.legends.map((legend, i) => (
                  <Line
                    key={legend}
                    type="monotone"
                    dataKey={legend}
                    dot={{ strokeWidth: 2 }}
                    strokeWidth={2}
                    stroke={orderCreation.colors[i]}
                  />
                ))}
              </LineChart>
            ) : (
              <div>&nbsp; No Data</div>
            )}
          </Col>
        </Row>
        <Drawer
          title="Download Failed Orders"
          width={'50%'}
          closable={false}
          onClose={this.onClose}
          visible={visibleDrawer}
        >
          <Fragment>
            <Row>
              <Col span={24}>
                <DescriptionItem title="Failed Orders" content={100} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <DescriptionItem
                  title="Start DateTime"
                  content={filter.startDate}
                />
              </Col>
              <Col span={12}>
                <DescriptionItem
                  title="End DateTime"
                  content={filter.endDate}
                />
              </Col>
            </Row>
            <Divider />

            <Form layout="vertical" hideRequiredMark>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Email Subject">
                    <Input
                      name="report_identifier"
                      value={report_identifier}
                      placeholder="Please enter email subject"
                      onChange={this.inputChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Email IDs">
                    <Select
                      mode="tags"
                      placeholder="Please enter emailids here"
                      value={email_to_list}
                      style={{ width: '100%' }}
                      onChange={this.handleEmailChange}
                      tokenSeparators={[',']}
                    >
                      {emails}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Fragment>

          <div
            style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e8e8e8',
              padding: '10px 16px',
              textAlign: 'left',
              left: 0,
              background: '#fff',
              borderRadius: '0 0 4px 4px'
            }}
          >
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={this.handleOk}
              disabled={
                email_to_list.length < 1 || !report_identifier ? true : false
              }
              style={{
                marginRight: 8
              }}
            >
              Submit
            </Button>
            <Button onClick={this.onClose}>Cancel</Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

TrackingDelay.propTypes = {
  config: PropTypes.object,
  metadata: PropTypes.object,
  orderCreation: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchCP: PropTypes.func,
  fetchOrderCreationStats: PropTypes.func,
  resetCPs: PropTypes.func,
  fetchServiceMetaData: PropTypes.func,
  orderCreationChartChange: PropTypes.func,
  generateOrderCreationReport: PropTypes.func
};

TrackingDelay.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  orderCreation: state.session.orderCreation
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: data =>
    dispatch(fetchActiveReportsMetaData(data)),
  fetchCP: query => dispatch(fetchCP(query)),
  fetchOrderCreationStats: query => dispatch(fetchOrderCreationStats(query)),
  resetCPs: () => dispatch(resetCPs()),
  fetchServiceMetaData: () => dispatch(fetchServiceMetaData()),
  orderCreationChartChange: value => dispatch(orderCreationChartChange(value)),
  generateOrderCreationReport: query =>
    dispatch(generateOrderCreationReport(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrackingDelay)
);
